import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const peppolStatusEvents = eventGroup({
  source: 'Peppol Status',
  events: {
    changed: type<void>(),
  },
});
